// extracted by mini-css-extract-plugin
module.exports = {"hideTooltip":"yu","fadeIn":"zu","delay":"Au","recommendedSizeTooltip":"Bu"};